import { getISOString } from 'owa-datetime';
import type { DateRange } from 'owa-datetime-utils';

// Retrieves the and ISO string for the start and end dates of a date string
// This enables us to create very explicit keys for date ranges
export function getDateRangeISOString(dateRange: DateRange): string {
    return getISOString(dateRange.start) + '--' + getISOString(dateRange.end);
}
